import axios from 'services/index';
import config from 'config/config';

/**
 * Get zone details using post code
 */
export async function getZoneByPostCode(data) {
    return axios.get(`${config.API_URL}portal/postcode/zone`, {params: data})
}